import React, {useContext} from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { gql, useQuery } from '@apollo/client';

import SidebarQuizWithLeaderBoard from '../components/sidebar-quiz-with-leaderboard';
import QuizLiveAnswer from '../components/quiz-live-answer';
import { Presentation } from '../types/presentation';
import SideBarBtns from '../components/sidebar-btns';
import { InLinePreLoader } from '../components/preloader';
import { useHistory } from 'react-router-dom';
import UserContext from '../contexts/user';
import EventContext from '../contexts/event';
import LocaleSwitcher from '../components/locale-switcher';
import TopBar from '../components/top-bar';
import MobileBottomNav from "../components/mobile-bottom-nav";

const QuizAnswersWithLeaderBoard:React.FC<{
  presentation:Presentation;
  locale:string; setLocale:(arg0:string) => void;
}> = ({ presentation, locale, setLocale }) => {
  const eventContext = useContext(EventContext);
  const userContext = useContext(UserContext);
  const history = useHistory();
  const { data, loading } = useQuery<{
    question: Array<{
      order: number;
      question: string;
      options: Array<{
        id: string;
        correct: boolean;
        option: string;
        votes: number;
      }>
    }>
  }>(gql`
    query (
      $presentation_id: String!
    ) {
      question(where: {
        presentation_id: {
          _eq: $presentation_id
        }
      }, order_by: {
        order: asc
      }) {
        id
        order
        question
        options {
          id
          correct
          option
          votes
        }
      }
    }
  `, {
    variables: {
      presentation_id: presentation._id
    }
  })

  if(loading) {
    return <InLinePreLoader />
  }

  const questions = data?.question.filter((q) => q.options.find((o) => !o.correct)) || [];

  return (
    <>
    { console.log("sidebar >>>1")}
      <SideBarBtns presentation={presentation} />
      <div className="grid-contianer quiz-user-container">
        <LocaleSwitcher locale={locale} setLocale={setLocale} />
        <div className="sidebar">
        <TopBar
              presentation={presentation}
              forumIsOpen={false}
              tab={0}
              forum={false}
              hasVideo={presentation.video?true: false}
          />
          <SidebarQuizWithLeaderBoard presentation={presentation} />
        </div>
        <div className="main bg-dark-grey mobile-bg-dark-grey c-pad-fix c-pad-result">
          <Container>
            <MobileBottomNav presentation={presentation} tab={3}/>
          {/*<Row className="top-menu-container fixed-to-left">*/}
          {/*    <Col md></Col>*/}
          {/*    <Col md></Col>*/}
          {/*    <Col lg={6} xl={4}>*/}
          {/*    {*/}
          {/*        (eventContext.forum || eventContext.quiz) &&*/}
          {/*        <div className="top-menu pad-0 top-menu-mob">*/}
          {/*          <Button onClick={() => history.push(`/${eventContext.slug}`)} color="primary" className="back-to-main d-block d-lg-none"><img src="/icons/arrow-back-white.svg" alt="back" /></Button>*/}
          {/*          <Button color="primary" className="nav-link d-block d-lg-none" onClick={() => {*/}
          {/*            history.push(`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`)*/}
          {/*          }}><img className="d-none d-lg-block" src="/icons/forum-ico.svg" alt="forum" /><img className="d-block d-lg-none" src="/icons/forum-ico-mob.svg" alt="forum" /><span>Forum</span></Button>*/}
          {/*          {*/}
          {/*            eventContext.quiz &&*/}
          {/*            <Button color="primary" className="nav-link d-block d-lg-none" onClick={() => {*/}
          {/*              userContext.user ?*/}
          {/*              history.push(`/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`)*/}
          {/*              :*/}
          {/*              userContext.setShowLogin(true)*/}
          {/*            }}><img className="d-none d-lg-block" src="/icons/quiz-ico.svg" alt="quiz" /><img className="d-block d-lg-none" src="/icons/quiz-ico-mob.svg" alt="quiz" />*/}
          {/*              <span>Quiz</span>*/}
          {/*            </Button>*/}
          {/*          }*/}
          {/*          <Button color="primary" className="active nav-link d-block d-lg-none" onClick={() => { history.push(`/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`) }}><img className="d-block d-lg-none" src="/icons/quiz-ico-mob.svg" alt="quiz" /></Button>*/}
          {/*          /!* TODO: WIP*/}
          {/*          { userContext.user?.moderator && <Button color="primary" className="nav-link d-block d-lg-none" onClick={() => { history.push(`/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`) }}><img className="d-block d-lg-none" src="/icons/quiz-ico-mob.svg" alt="quiz" /></Button> } *!/*/}
          {/*          <Button className="nav-link d-block d-lg-none" onClick={() => history.push(`/${eventContext.slug}/${presentation._id}${document.location.search}`)}><img className="d-none d-lg-block" src="/icons/video-ico.svg" alt="watch video" /><img className="d-block d-lg-none" src="/icons/video-ico-mob.svg" alt="watch video" /></Button>*/}
          {/*        </div>*/}
          {/*      }*/}
          {/*    </Col>*/}
          {/*  </Row>*/}
          </Container>
          <div className="answers-main">
            <Container>
              <Row>
                <Col>
                  {
                    questions.map((q, index) => <div className="quiz-live-answers-container q-a-block m-t-60">
                        <h5 className="text-primary">PODIUM question {index + 1}/{questions.length}</h5>
                        <p className="text-white">{q.question}</p>
                        {
                          q.options.map((option, index) => (
                            <QuizLiveAnswer
                              answerLength={q.options.length}
                              key={option.id}
                              alphabet={String.fromCharCode(index + 97)}
                              answer={option.option}
                              totalAnswers={option.votes}
                              totalAnswersAggregate={q.options.reduce((sum, qo) => sum + qo.votes, 0)}
                              value={option.correct}
                            />
                          ))
                        }
                      </div>
                    )
                  }
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  )
}

export default QuizAnswersWithLeaderBoard;
